module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "titleName"
  }, [_c('span', {
    staticStyle: {
      "color": "#00A5D5"
    }
  }, [_vm._v(_vm._s(_vm.secTitle))]), _vm._v(" "), (_vm.content != '') ? _c('span', {
    attrs: {
      "id": "content"
    }
  }, [_vm._v("( " + _vm._s(_vm.content) + ")")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "orderUpload"
  }, [_c('div', {
    staticClass: "order-upload-wrap"
  }, [_c('div', {
    staticClass: "order-file-wrap"
  }, [_c('el-upload', {
    staticClass: "upload-file model",
    attrs: {
      "action": "",
      "before-upload": _vm.handleChange,
      "http-request": _vm.uploadFile,
      "before-remove": _vm.beforeRemove,
      "on-remove": function (file, fileList) {
        _vm.handleRemove(file, fileList, _vm.dataType)
      },
      "data": {
        objectType: _vm.dataType,
        objectTag: _vm.subCatalogId + '_' + _vm.form.demPatient
      },
      "file-list": _vm.dataType == '07' ? _vm.dataScan : _vm.dataCbct,
      "on-exceed": _vm.handleExceed,
      "auto-upload": true,
      "limit": 3,
      "multiple": ""
    }
  }, [_c('div', {
    staticClass: "upload-file-dragger1"
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), (this.currentStep == 5 && _vm.dataScan.length == 0) ? _c('span', {
    attrs: {
      "id": "tip"
    }
  }, [_vm._v("请上传扫描数据")]) : _vm._e()])], 1)])]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "example"
    },
    on: {
      "click": function($event) {
        _vm.isShow = !_vm.isShow
      }
    }
  }, [_vm._v("示例")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-fade-in-linear"
    }
  }, [(_vm.list.length == 3) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "item"
  }, _vm._l((_vm.list), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "example",
      style: (i == 0 ? 'margin-left:50px;' : '')
    }, [_c('img', {
      style: (i == 2 ? 'width:400px;' : ''),
      attrs: {
        "src": item.imgUrl,
        "alt": "item.label"
      }
    })])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.list.length == 2) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    staticClass: "item-two"
  }, _vm._l((_vm.list), function(item, i) {
    return _c('div', {
      key: i,
      style: (i == 1 ? 'margin-left:50px;' : '')
    }, [_c('img', {
      attrs: {
        "src": item.imgUrl,
        "alt": "item.label"
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "copyright",
      attrs: {
        "src": "/static/images/orthodontics/smiling-orthodontics.jpg"
      }
    })])
  }), 0) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a213cb4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/components/modelUpload.vue
// module id = 616
// module chunks = 0